import React, { useEffect, useState, useLayoutEffect, useRef } from 'react'
import { Box } from '@mui/material'
import { LoaderWrapper, ReportHeading, D3Pie, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { behavior } from '../../../../assets/images/icons'
import { useGlobalStore } from '../../../../store'
import { getImageUrl, getObjectAsArray } from '../../../../util'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import ReportEditCategoryPersona from './reportEditCategoryPersona'
import D3DoubleHalfPieChart from './d3DoublePieChart'

import {
  ContentWrap,
  RootWrap,
  SegmentRowContent,
  SegmentRow,
  SegmentWrap,
  PersonaTopSection,
  PersonaTopHeader,
  PersonaIconWrapper,
  PersonaTitle,
  PersonaDescriptionText,
  PersonaMetaRow,
  PersonaMetaWrapper,
  PersonaMetaLabel,
  PersonaMetaChips,
  PersonaChip,
  PersonaList,
  Divider,
  PropertyListingOutertWrapper,
  PropertyListingtWrapper,
  PropertyListingtHeading,
  PropertyChipsRow,
  PropertyChip as PropertyChipStyled,
  PersonaCard,
  PropertyListingHeading,
  BehaviorListingOuterWrapper,
  BehaviorListingWrapper,
  BehaviorListingHeading,
  BehaviorListUl,
  BehaviorList,
  DriversListingOutertWrapper,
  DriversListingtWrapper,
  DriversListingTitle,
  DriversListingBarWrapper,
  DriversBarTrack,
  DriversBarFill,
  DriversPercentLabel,
  DriversListingtDescription,
  OpportunitiesListingOuterWrapper,
  OpportunitiesInnerWrapper,
  OpportunitiesContentWrapper,
  PersonaDescriptionInnerWrapper,
  LhsMenuWrapper,
  LhsMenu
} from './style'

const ReportCategoryPersonaV2 = (props) => {
  const [reportData, setReportData] = useState()
  const [excelData, setExcelData] = useState()
  const [colorData, setColorData] = useState()
  const { user } = useGlobalStore()
  const { updateSubLhsApiLoaded } = useUpdateLhs()

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: ReportsService.getCategoryPersona,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  const onSuccessEdit = () => {
    refetch()
  }

  const CategoryPersonaEditButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && reportData?.PersonaDescription && (
          <ReportEditCategoryPersona
            InsightsElementId={props.InsightsElementId}
            pageData={reportData}
            onSuccess={onSuccessEdit}
            title={props.Title}
          />
        )}
      </>
    )
  }

  const brandSkewItems = reportData?.BrandSkew ? reportData.BrandSkew.split(',').map((item) => item.trim()).filter(Boolean) : [];

  const onSuccessFunc = (resp) => {
    setReportData(resp)

    const excelData = {
      properties: [],
      behaviors: [],
      categoryDrivers: [],
      brandSkew : [],
    };

    for (const i of resp.PersonaProperties) {
      for (const j of i.PersonaPropertyValuesHighlighted.PersonaPropertyValueHighlighted) {
        if (j.PersonaPropertyHighlighted) {
          excelData.properties.push([{ value: j.PersonaPropertyName }, { value: j.PersonaPropertyValue }])
        }
      }
    }

    for (const i of resp.PersonaBehaviors) {
      for (const j of Array.isArray(i?.PersonaBehaviorAttributes?.string) ? i?.PersonaBehaviorAttributes?.string : [i?.PersonaBehaviorAttributes?.string]) {
        excelData.behaviors.push([{ value: i.PersonaBehaviorName }, { value: j }])
      }
    }

    for (const i of resp.PersonaDrivers) {
      excelData.categoryDrivers.push([{ value: i.PersonaDriverName }, { value: i.PersonaDriverPercent }, { value: i.PersonaDriverDescription }])
    }    

    let brandSkew = resp?.BrandSkew ? resp?.BrandSkew.split(',') : [];

    for (const i of brandSkew) {
      excelData.brandSkew.push([{ value: i.trim() }])
    }

    setExcelData(excelData)

    const color = resp?.PersonaColor
    setColorData(color)
    updateSubLhsApiLoaded(props)
  }

  useEffect(() => {
    if (isSuccess && data) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        downloadId={props.type}
        {...props}
        additionalMiddleButton={<CategoryPersonaEditButton />}
        downloadIdData={excelData}
        // excel={false}
      />
      <ReportOuterWrapper>
        <RootWrap id={props.type} className={`personaSection1  ${(props?.isPPTModalActive || props?.isProgressionActive) ? 'exportToPPT' : ''}`}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <ContentWrap>
              {reportData && (
                <SegmentWrap className='segmentWrap'>
                  <SegmentRow className='segmentChild'>
                    <SegmentRowContent>
                      <TopOverviewSection 
                        reportData={reportData} 
                        colorData={colorData} 
                        brandSkewItems={brandSkewItems}
                      />
                      <TopPropertiesSection 
                        reportData={reportData} 
                        colorData={colorData}
                        heading={reportData?.PersonaPropertiesHeading}
                      />
                    </SegmentRowContent>
                  </SegmentRow>
                  <SegmentRow className='segmentChild'
                    heading={reportData?.PersonaBehaviorsHeading}
                  >
                    <SegmentRowContent>
                      <BehaviorListing color={colorData} data={reportData?.PersonaBehaviors} />
                    </SegmentRowContent>
                  </SegmentRow>
                  <SegmentRow className='segmentChild categoryDrivers' heading={'Category Drivers'}>
                    <SegmentRowContent>
                      <DriversListing
                        color={colorData}
                        data={reportData?.PersonaDrivers}
                        heading={reportData?.PersonaBehaviorsHeading}
                      />
                    </SegmentRowContent>
                  </SegmentRow>
                  {reportData?.PersonaOpportunities && (
                    <SegmentRow heading={'Key Insights & Recommendations'} className='opportunities'>
                      <SegmentRowContent>
                        <OpportunitiesListing
                          color={colorData}
                          data={reportData?.PersonaOpportunities}
                          heading={reportData?.PersonaBehaviorsHeading}
                        />
                      </SegmentRowContent>
                    </SegmentRow>
                  )}
                </SegmentWrap>
              )}
            </ContentWrap>
          </LoaderWrapper>
        </RootWrap>

        <RootWrap id={`${props.type}__recommendation`} className={`personaSection2  ${(props?.isPPTModalActive || props?.isProgressionActive) ? 'exportToPPT' : ''}`}>
          <OpportunitiesListing
            color={colorData}
            data={reportData?.PersonaOpportunities}
            heading={reportData?.PersonaBehaviorsHeading}
          />
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportCategoryPersonaV2

const getCategoryColor = (i) => {
  return ['#6366F1', '#3B82F6', '#06B6D4', '#A855F7', '#EC4899'][i] 
}

const TopOverviewSection = ({ reportData, colorData, brandSkewItems }) => {
  const brandSkewItemsNew = getObjectAsArray(reportData.BrandSkewAndProgressions)
  return (
    <PersonaTopSection color={colorData} contentlength={reportData?.PersonaDescription.length < 400}>
      <PersonaTopHeader>
        <PersonaIconWrapper color={colorData}>
          <PersonaTitle>
            <PersonaCard bgColor={colorData}><span>{reportData?.PersonaName} ({reportData?.PersonaPercent}%)</span></PersonaCard>
            </PersonaTitle>
          {/*<PersonaTitle> {reportData?.PersonaName}</PersonaTitle> */}
        </PersonaIconWrapper>
        <PersonaDescriptionInnerWrapper>
          <PersonaDescriptionText
            dangerouslySetInnerHTML={{ __html: reportData?.PersonaDescription }}
          />
          {(reportData?.CategorySkew || brandSkewItemsNew.length > 0) && (
            <PersonaMetaRow>
              {reportData?.CategorySkew && (
                <PersonaMetaWrapper>
                  <PersonaMetaLabel>Category Skew</PersonaMetaLabel>
                  <PersonaChip color={colorData}>{reportData?.CategorySkew}</PersonaChip>
                </PersonaMetaWrapper>
              )}
              {brandSkewItemsNew.length > 0 && (
                <PersonaMetaWrapper>
                  <PersonaMetaLabel>Brand Skew</PersonaMetaLabel>
                  <PersonaMetaChips>
                    {brandSkewItemsNew.map((item, index) => (
                      <PersonaChip key={`${item.BrandName}-${index}`} color={colorData} isBrandSkew>
                        {item.BrandName} {item.BrandProgression && <span className={`direction${item.BrandProgression}`}></span>}
                      </PersonaChip>
                    ))}
                  </PersonaMetaChips>
                </PersonaMetaWrapper>
              )}
            </PersonaMetaRow>
          )}
        </PersonaDescriptionInnerWrapper>
      </PersonaTopHeader>
    </PersonaTopSection>
  )
}

const TopPropertiesSection = ({ reportData, colorData, heading }) => {
  if (!reportData?.PersonaProperties) return null
  
  return (
    <>
      <PropertyListing
        color={colorData}
        data={reportData?.PersonaProperties}
        heading={heading}
      />
    </>
  )
}

const PropertyListing = ({ color, data, heading }) => {
  return (
    <PropertyListingOutertWrapper>
      <PropertyListingHeading>{heading}</PropertyListingHeading>
      {data.map((persona1, i) => {
        const categoryColor = getCategoryColor(i)
        return (
          <PropertyListingtWrapper className='PropertyList addPadding' key={i}>
            <PropertyListingtHeading>{persona1.PersonaPropertyName}</PropertyListingtHeading>
            <PropertyChipsRow>
              {persona1.PersonaPropertyValuesHighlighted.PersonaPropertyValueHighlighted.map(
                (persona2, j) => {
                  return (
                    <PropertyChipStyled
                      key={j}
                      categoryColor={categoryColor}
                      selected={persona2?.PersonaPropertyHighlighted}
                    >
                      {persona2.PersonaPropertyValue}
                      {persona2.PersonaPropertyProgression && <span className={`direction${persona2.PersonaPropertyProgression}`}></span>}
                    </PropertyChipStyled>
                  )
                }
              )}
            </PropertyChipsRow>
          </PropertyListingtWrapper>
        )
      })}
    </PropertyListingOutertWrapper>
  )
}

const PropertyChipIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ marginRight: '4px' }}>
    <path d="M11.667 3.5L5.25 9.917L2.333 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const parseBehaviorAttributesToChartData = (attributes, baseColor) => {
  if (!attributes || attributes.length === 0) return []

  return attributes
    .map((attr, idx) => {
      const strAttr = String(attr || '').trim() // 
      const percentMatch = strAttr.match(/(\d+(?:\.\d+)?)\s*%?/) || strAttr.match(/(\d+(?:\.\d+)?)(?=\s*$)/)

      if (percentMatch) {
        const value = Math.min(100, Math.max(0, Number(percentMatch[1])));
        const name = strAttr.split('(')[0].trim();

        let names = [name];

        if (name.includes('/')) {
          const [left, right] = name.split('/').map(s => s.trim());

          if (left.length <= right.length) {
            names = [`${left}/`, right];
          } else {
            names = [left, `/${right}`];
          }
        }

        return {
          value,
          name: names,
        };
      }
      
      return null
    })
    .filter(Boolean)
}

const behaviorListingDataFunc = (input) => {
  const parseName = (str) => {
    const result = [];

    str.split(" ").forEach(word => {
      if (word.includes("/")) {
        const [left, right] = word.split("/");

        // Special case for Media/Entertainment
        if (left === "Media") {
          result.push(left + "/");
          result.push(right);
        } else {
          result.push(left);
          result.push("/" + right);
        }
      } else {
        result.push(word);
      }
    });

    // Already 2 parts or less
    if (result.length <= 2) {
      return result;
    }

    // Split from the middle
    const mid = Math.ceil(result.length / 2);

    return [
      result.slice(0, mid).join(" "),
      result.slice(mid).join(" ")
    ];
  };
  return input.map((item,i) => ({
    PersonaBehaviorIcon: item.PersonaBehaviorIcon,
    PersonaBehaviorName: item.PersonaBehaviorName,
    PersonaId: item.PersonaId,
    PersonaBehaviorAttributes: getObjectAsArray(item.PersonaBehaviorAttributes.PersonaBehaviorAttribute).map(attr => {
      const match = attr.PersonaBehaviorAttributeName.match(/^(.*?)\s*\((\d+)%\)$/);

      return {
        name: parseName(match ? match[1] : attr.PersonaBehaviorAttributeName),
        value: match ? Number(match[2]) : 0,
        direction: attr.PersonaBehaviorAttributeProgression || ""
        // direction: i === 0 ? 'Up' : 'Down'
      };
    })
  }));
}

const BehaviorListing = ({ color, data }) => {
  const finalData = behaviorListingDataFunc(data)

  return (
    <BehaviorListingOuterWrapper>
      {finalData?.map((persona1, i) => {

        return (
          <BehaviorListingWrapper className='BehaviorListing' key={i}>
            {persona1.PersonaBehaviorAttributes.length > 0 && (
              <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
                <D3DoubleHalfPieChart rawData={persona1.PersonaBehaviorAttributes} heading={persona1.PersonaBehaviorName} />
              </div>
            )}
          </BehaviorListingWrapper>
        )
      })}
    </BehaviorListingOuterWrapper>
  )
}


const DriversListing = ({ color, data }) => {
  // Use a ref to store all bar wrapper DOM elements
  const barRefs = useRef([]);
  // Store the calculated minimum width in state
  const [minWidth, setMinWidth] = useState(0);
  const [minWidths, setMinWidths] = useState(0);


const handleRef = (index) => (el) => {
  if (!el) return;

  const width = el.getBoundingClientRect().width;

  setMinWidths((prev) => {
    if (prev[index] === width) return prev;
    return {
      ...prev,
      [index]: width+5,
    };
  });
};

  useLayoutEffect(() => {
    setTimeout(() => {
      if (barRefs.current.length > 0) {
        // Get the width of each wrapper
        const widths = barRefs.current.map((el) => el?.getBoundingClientRect().width || 0);
        // Filter out 0 widths and find the minimum
        const validWidths = widths.filter((w) => w > 0);
        if (validWidths.length > 0) {
          setMinWidth(Math.min(...validWidths));
        }
      }
    }, 10)
  }, [data]); // Re-calculate if data changes

  return (
    <DriversListingOutertWrapper>
      {data?.map((persona1, i) => {
        const percent = Number(persona1.PersonaDriverPercent) || 0
        if (percent <= 0) return false

        const fillColor = color || '#3B82F6'
        return (
          <DriversListingtWrapper key={i}>
            <DriversListingTitle>{persona1.PersonaDriverName}</DriversListingTitle>
            <DriversListingBarWrapper
              ref={(el) => (barRefs.current[i] = el)}
              maxWidthValue={minWidth}
            >
              <Box className='driversBarTrackWrapper'>
                <DriversBarTrack>
                  <DriversBarFill width={percent} color={fillColor} />
                  <DriversPercentLabel>{percent}%</DriversPercentLabel>
                </DriversBarTrack>
              </Box>
            </DriversListingBarWrapper>

            {persona1?.PersonaDriverDescription && (
              <DriversListingtDescription color={color}
                ref={handleRef(i)}
                style={{
                  minWidth: minWidths[i]
                    ? `${Math.ceil(minWidths[i])}px`
                    : undefined,
                }}
              >
                {persona1?.PersonaDriverDescription}
              </DriversListingtDescription>
            )}
          </DriversListingtWrapper>
        )
      })}
    </DriversListingOutertWrapper>
  )
}

const OpportunitiesListing = ({ color, data }) => {
  const wrapperRef = useRef(null);
  const [lhsMenu, setLhsMenu] = useState([])

  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;
    try {
      let listItems = [];
      const topUls = root.querySelectorAll(':scope > ul');
      if (topUls && topUls.length > 0) {
        topUls.forEach((ul) => {
          Array.from(ul.children).forEach((child) => {
            if (child.tagName === 'LI') listItems.push(child);
          });
        });
      } else {
        // Fallback for environments that don't support :scope — inspect direct children
        Array.from(root.children).forEach((child) => {
          if (child.tagName === 'UL') {
            Array.from(child.children).forEach((li) => {
              if (li.tagName === 'LI') listItems.push(li);
            });
          }
        });
      }

      listItems.forEach((li) => li.classList.add('segmentChild'));
    } catch (err) {
      // If anything unexpectedly fails, fall back to the original selector (best-effort)
      try {
        const listItems = root.querySelectorAll('ul > li');
        listItems.forEach((li) => li.classList.add('segmentChild'));
      } catch (e) {
        // non-fatal
      }
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const h4Array = [...doc.querySelectorAll("h4")].map(h4 => h4.textContent.trim()).map((d, i) => ({title:d, active:i === 0}));
    setLhsMenu(h4Array)
  }, [data]);

  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;
    try {
      let listItems = [];
      const topUls = root.querySelectorAll(':scope > ul');
      if (topUls && topUls.length > 0) {
        topUls.forEach((ul) => {
          let actInd = 0;
          for(let i=0; i<lhsMenu.length; i++){
            if(lhsMenu[i]?.active){
              actInd = i
            }
          }

          Array.from(ul.children).forEach((child, i) => {
            if (i === actInd) {
              child.classList.add('active-li');
            } else {
              child.classList.remove('active-li');
            }
          });
        });
      }

    } catch (err) {
    }

  }, [lhsMenu]);

  const lhsMenuClicked = (index) => {
    const h4Array = [...lhsMenu].map((d, i) => ({...d, active:i === index}));
    setLhsMenu(h4Array)
  }

  return (
    <OpportunitiesListingOuterWrapper className='opportunitiesListing'>
      <OpportunitiesInnerWrapper color={color}>
        {lhsMenu && <LhsMenuWrapper className='lhsMenu'>
          {lhsMenu.map((item, index) => {
            const isNextActive = index < lhsMenu.length - 1 && lhsMenu[index + 1]?.active;
            return (<LhsMenu key={index} color={color} className={`${isNextActive ? 'nextActive' : ''} ${item?.active ? 'active' : ''}`} onClick={() => lhsMenuClicked(index)}>{item.title}</LhsMenu>)
          })}
        </LhsMenuWrapper>}
        <OpportunitiesContentWrapper className='rte' ref={wrapperRef} color={color} dangerouslySetInnerHTML={{ __html: data }} />
      </OpportunitiesInnerWrapper>
    </OpportunitiesListingOuterWrapper>
  )
}
